import { render } from "./TermList.vue?vue&type=template&id=f1c81a20"
import script from "./TermList.vue?vue&type=script&lang=js"
export * from "./TermList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__